import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from "react-router-dom";
import Modal from 'react-modal';
import { compose } from 'recompose';
import windowSize from 'react-window-size';
import moment from "moment";

import withAuthorization from '../auth/withAuthorization';
import UpdateIntro from "../huntcomponents/UpdateIntro";
import UpdateDetails from "../huntcomponents/UpdateDetails";
import HuntEnding from "../huntcomponents/HuntEnding";
import EditMapBounds from "../huntcomponents/UpdateBoundsOnMap";
import { FormattedLabelsAndValues } from "../huntcomponents/FormattedLabelsAndValues";
import BoundsOnMap from "./BoundsOnMap";
import UpdateGameType from "../huntcomponents/UpdateGameType";
import MainClueList from "../clues/MainClueList";


import {
   fetchGame,
   fetchAndAttachAuthorToGame,
   deleteGame,
   updateGame,
   fetchClueIcons, deleteClueImagesNoCallback
}
   from "../../actions/index";

import {
   AUTHOR_NAME, CREATED, DIFFICULTY,
   INTRO, LOC_NAME, PUBLIC, PUBLISHED,
   DURATION, TREASURE_TYPE,
   EVENT_DATE, TREASURE_DESCRIPTION, LAST_MODIFIED
}
   from "../../constants/Game";

import {
   Header, Title, HuntStatus, PrivatePublicBlock
} from "./GameDetailComponents"

import '../../global.css';
import './GameDetail.css'
import {ConfirmDelete, MessageDialog} from "../huntcomponents/dialogs";
import { convertGame, selectGame } from "../../actions";
import SimpleFileInput from "../image/SimpleFileInput";
import {deleteFileInFbStorage, PhotoUpload, processFile} from "../image/PhotoUpload";
import {COMMON_DATE} from "../../constants/Strings";
import {fetchDeeplinkForGame} from "../../actions/restcalls";

/**
 *  The biggest chunk of code and busiest page in the app.  You have reached the center of the labyrinth!
 *
 *  Shows the details of the an existing game, including basic info
 *  (author, date created, players played, descriptive
 *  name of location), maps of bounds, game introduction, and clues.
 *
 *  This page also allows editing of editable game elements
 *  (intro, descriptive loc name, map bounds, introduction, and
 *  clues) unless the user is not the author or an admin.
 */
class GameDetail extends Component {
   constructor(props) {
      super(props);

      // local state usually pertains to form/edit modals being open or note
      this.state = {
         editIntroModalIsOpen: false,
         editDetailsModalIsOpen: false,
         editGameTypeModalIsOpen: false,
         editMapModalIsOpen: false,
         editHuntEndingModalIsOpen: false,
         convertConfirmationModalIsOpen: false,
         deleteConfirmIsOpen: false,
         isFetching: false,
         loadingImage: false
      };

      // Use 'bind()' to make sure 'this' means this class instance inside these methods.
      this.openIntroductionModal = this.openIntroductionModal.bind(this);
      this.closeIntroductionModal = this.closeIntroductionModal.bind(this);
      this.openDetailsModal = this.openDetailsModal.bind(this);
      this.closeDetailsModal = this.closeDetailsModal.bind(this);
      this.openGameTypeModal = this.openGameTypeModal.bind(this);
      this.closeGameTypeModal = this.closeGameTypeModal.bind(this);
      this.openMapModal = this.openMapModal.bind(this);
      this.closeMapModal = this.closeMapModal.bind(this);
      this.openHuntEndingModal = this.openHuntEndingModal.bind(this);
      this.closeHuntEndingModal = this.closeHuntEndingModal.bind(this);
      this.openDeleteModal = this.openDeleteModal.bind(this);
      this.closeDeleteModal = this.closeDeleteModal.bind(this);
      this.onDeleteClick = this.onDeleteClick.bind(this);
      this.onDelete = this.onDelete.bind(this);
      this.onPublishClick = this.onPublishClick.bind(this);
      this.onUnpublishClick = this.onUnpublishClick.bind(this);
      this.onConvertClick = this.onConvertClick.bind(this);
      this.genQuickLinkClicked = this.genQuickLinkClicked.bind(this);
      this.closeConvertConfirmationModal = this.closeConvertConfirmationModal.bind(this);
      this.convertGameConfirmed = this.convertGameConfirmed.bind(this);
      this.onDrop = this.onDrop.bind(this);
      this.photoUploadComplete = this.photoUploadComplete.bind(this);
      this.errorUploadingPhoto = this.errorUploadingPhoto.bind(this);
   }

   componentDidMount() {
      const {games, fetchAndAttachAuthorToGame} = this.props;
      const id = this.gameId();

      // If we don't have data, fetch it and return
      if (!games || !games[id]) {
         return;
      }

      if (!games[id].authorName) {
         fetchAndAttachAuthorToGame(games[id])
      }
      this.resetScroll();
   }

   openIntroductionModal() {
      this.setState({editIntroModalIsOpen: true});
   }

   closeIntroductionModal() {
      this.setState({editIntroModalIsOpen: false});
   }

   openDetailsModal() {
      this.setState({editDetailsModalIsOpen: true});
   }

   closeDetailsModal() {
      this.setState({editDetailsModalIsOpen: false});
   }

   openGameTypeModal() {
      this.setState({editGameTypeModalIsOpen: true});
   }

   closeGameTypeModal() {
      this.setState({editGameTypeModalIsOpen: false});
   }

   openMapModal() {
      this.setState({editMapModalIsOpen: true});
   }

   closeMapModal() {
      this.setState({editMapModalIsOpen: false});
   }

   openHuntEndingModal() {
      this.setState({editHuntEndingModalIsOpen: true});
   }

   closeHuntEndingModal() {
      this.setState({editHuntEndingModalIsOpen: false});
   }

   onConvertClick() {
      this.setState({convertConfirmationModalIsOpen: true});
   }

   genQuickLinkClicked() {
      // assumes game is private
      this.setState( {  isFetching: true});

      const callback = () => {
         this.setState( {  isFetching: false});
      }

      const errorCallback = (errorMsg) => {
         this.setState( {  isFetching: false});
         alert("Unable to generate quick link.  " + errorMsg)
      }

      fetchDeeplinkForGame(this.gameId(), this.game()[PUBLIC], callback, errorCallback);
   }

   closeConvertConfirmationModal() {
      this.setState({convertConfirmationModalIsOpen: false});
   }

   openDeleteModal() {
      this.setState({deleteConfirmIsOpen: true});
   }

   closeDeleteModal() {
      this.setState({deleteConfirmIsOpen: false}
      );
   }

   // callback from PhotoUpload
   photoUploadComplete(newUrl) {

      const game = this.game();
      if (newUrl == null && game.hunt_picture == null) {
         this.setState( { loadingImage: false } )
         return;
      }

      const values = { hunt_picture: newUrl }
      updateGame(game.id, game.isPublic, values,
         () => { this.setState( { loadingImage: false } ) });
   }

   // callback from PhotoUpload
   errorUploadingPhoto(errorMsg) {
      this.setState( { loadingImage: false } )

      if (!!errorMsg) {
         alert(errorMsg)
      }
   }

   // callback from file chooser for image upload
   onDrop(files) {
      const file = files[0]
      if (!file) {
         return;
      }
      // this will trigger file processing and image upload by PhotoUpload component.
      this.setState( { loadingImage: true } )
      const game = this.game();
      const hasOldPhoto = !! game.hunt_picture;
      if (hasOldPhoto) {
         deleteFileInFbStorage(game.hunt_picture)
      }
      processFile(file,
         'hunt_picture', null,
         game.id, game.authorId,
         game.isPublic,
         game.created,
         this.photoUploadComplete, this.errorUploadingPhoto )
   }

   resetScroll() {
      window.scrollTo(0, 0)
   }

   // Returns dimensions 1/4 x 1/4 window size or 146x128, whichever is larger.
   calculateMapThumbDimensions() {

      const minDimensions = {width: 146, height: 128};
      const { windowWidth } = this.props;

      const width = Math.max(windowWidth / 4, minDimensions.width);
      const height = Math.max(windowWidth / 4, minDimensions.height);

      return {width, height}
   }

   // Returns dimensions 2/3 x 1/2 window size or 300x280, whichever is larger.
   calculateMapDialogDimensions() {
      const minDimensions = {width: 300, height: 210};
      const { windowWidth } = this.props;

      const width = Math.max(windowWidth * 2 / 3, minDimensions.width);
      const height = Math.max(windowWidth * 2 / 5, minDimensions.height);
      return {width, height}
   }

   // The user has clicked "Delete" game.
   onDeleteClick() {
      this.openDeleteModal();
   }

   onDelete() {
      const {id} = this.props.match.params;
      const game = this.props.games[id];

      const clues = game.clues;
      if (!!clues) {
         clues.forEach((clue) => {
            deleteClueImagesNoCallback(clue);
         });
      }
      if (!!game.hunt_picture) {
         deleteFileInFbStorage(game.hunt_picture)
      }

      const isPublic = game.isPublic;

      // If we made it here, we have no clues,  so allow delete.
      this.props.deleteGame(id, isPublic, () => {
         this.props.history.push('/games');
      });
   }

   onPublishClick() {

      const {id} = this.props.match.params;
      const values = {[PUBLISHED]: true, [PUBLIC]: this.game().isPublic};

      updateGame(id, values.isPublic, values, () => {
      });
   }

   onUnpublishClick() {
      const values = {[PUBLISHED]: false, [PUBLIC]: this.game().isPublic};

      const {id} = this.props.match.params;
      updateGame(id, values.isPublic, values, () => { });
   }

   convertGameConfirmed() {
      this.setState( {  isFetching: true, convertConfirmationModalIsOpen: false});

      const callback = (docRef) => {
         this.setState( {  isFetching: false});

         const id = docRef.id;
         this.props.selectGame({ id: id});
         // hack to get new page to show, against an unknown bug or mistake
         this.props.history.push('/games');
         this.props.history.push(`/games/${id}`);
      };
      const error = (msg) => {
        alert("Failed to convert game.  Reason: " + msg)
      };

      convertGame(this.game(), callback, error);
   }

   // helper to grab the id
   gameId() {
      return this.props.match.params.id;
   }

   // helper to grab the game
   game() {
      const {games} = this.props;
      return games[this.gameId()];
   }

   // helper function to get data Strings to pack textual tables.
   textualTablesFromGame(game) {

      // First table  (Label: Value).  Whether the content was authored by author,
      // as opposed to automatic, determines the style

      const creationDateText =  moment(game[CREATED].toDate()).format(COMMON_DATE);
      const updatedDateText = game[LAST_MODIFIED] ? moment(game[LAST_MODIFIED].toDate()).format(COMMON_DATE) : "";

      let labels1 = [];
      let values1 = [];
      let userWritten1 = [];
      labels1.push("Author");
      values1.push(game[AUTHOR_NAME]);
      userWritten1.push(false);
      labels1.push("Created");
      values1.push(creationDateText);
      userWritten1.push(false);
      labels1.push("Updated");
      values1.push(updatedDateText);
      labels1.push("Duration");
      values1.push(game[DURATION]);
      userWritten1.push(false);
      labels1.push("Located");
      values1.push(game[LOC_NAME]);
      userWritten1.push(true);
      labels1.push("Difficulty");
      values1.push(game[DIFFICULTY]);
      userWritten1.push(true);

      // second table
      let labels2 = [];
      let values2 = [];
      let userWritten2 = [];
      labels2.push("Event Hunt");
      const eventHuntValue = !!game[EVENT_DATE] ? "Yes!!" : "No";
      values2.push(eventHuntValue);
      userWritten2.push(true);

      return { labels1, values1, userWritten1, labels2, values2, userWritten2 }
   }

   render() {
      const {games, fetchGame, user, isAdmin, clueIcons } = this.props;

      const id = this.gameId();

      // If we don't have data, start a call to fetch it and return
      if (!games || !games[id]) {
         fetchGame(id);
         return <div>
            Loading...
            <div className="my-modal-overlay"/>}
            <div className="loader"/>
         </div>
      }
      if (!clueIcons) {
         fetchClueIcons()
      }

      // Authors and admins can edit
      let editable = (user && user.id === games[id].authorId) || isAdmin;

      const game = games[id];
      const { lastPlayed, isPublished, bounding_box, eventDate, isPublic, hunt_picture, isSample } = game;

      const hasBeenPlayed = !!lastPlayed;
      const activityLinkText = hasBeenPlayed ? "View Hunt Activity" : "No game plays yet.";

      // Display the properties of game

      const bounds = bounding_box;
      const {width, height} = this.calculateMapThumbDimensions();
      const dialogDims = this.calculateMapDialogDimensions();

      const activityPage = `/games/${this.gameId()}/activity`;

      const isEvent = !!eventDate;

      const confirmTitle = isPublic ? "Make Private?" : "Make Public?";
      const confirmMessage = buildConfirmMessage(isPublic, isPublished);

      // const publishedState = notPublishableText ? "Not Published" : "Published";
      // const noWinCodeText = game[WIN_CODE] ? "" : "By having no win code, the user can win the game by simply clicking a 'Found Treasure' button.";

      // String for tabular data on page.
      const { labels1, values1, userWritten1, labels2, values2, userWritten2 } = this.textualTablesFromGame(game);

      const eventDateMoment = isEvent ? moment(eventDate.toDate()).format('ddd, MMM Do YYYY, hh:mm a') : "";

      const hasPhoto = !!hunt_picture;
      const photoButtonText = hasPhoto ? "(Change image)" : "(Choose image)";

      return (
         <div className='editor' ref="base-game-container">

            <Header
               game={game}
            />

            <Title game={game} className="col-xs-12 col-sm-8 col-md-8"/>

            <HuntStatus className="col-xs-12 col-sm-4 col-md-4 bottom-margin pull-right top-margin-half"
               game = {game}
               editable={editable}
               isSample={isSample}
               fetchCodeClicked={() => fetchGame(this.gameId())}
               onUnpublishClick={this.onUnpublishClick}
               onPublishClick={this.onPublishClick}
               onDeleteClick={this.onDeleteClick}
            />

            <div className="pull-left col-xs-12 col-sm-8 col-md-6 no-side-margins">

               <div className="no-side-margins bottom-margin">
                  <Link className="no-side-margins accent-link" to={activityPage}>
                     {activityLinkText}
                  </Link>
               </div>

               {!hasBeenPlayed && !isPublished && <div className="small-top-margin big-bottom-margin larger">
                  <b>Note: </b> <span className="red-text"> You should test play your hunt in the app.</span>
                  <small> (You can do this in the app logged into your account before publishing.) </small>
               </div> }

               <FormattedLabelsAndValues
                  labels={labels1}
                  values={values1}
                  userWritten={userWritten1}/>

               {editable &&
               <button className="btn btn-link accent-link no-side-margins bottom-margin" onClick={this.openDetailsModal}>
                  (Edit details)
               </button>}
            </div>

            <h5 className="pull-right clear-right big-top-margin bottom-margin  col-xs-12 col-sm-4 col-md-4 ">
               Hunt bounds
            </h5>

            <div className="pull-right col-xs-12 col-sm-4 col-md-4 bottom-margin align-center">
               <BoundsOnMap
                  bounds={bounds}
                  height={height}
                  width={width}
                  editable={editable}
                  editCallback={this.openMapModal}
                  caption=""/>
            </div>

            <div className="col-xs-12 col-sm-8 col-md-8 no-side-margins">
               <FormattedLabelsAndValues
                  className="pull-left top-margin"
                  labels={labels2}
                  values={values2}
                  userWritten={userWritten2}/>

               {editable &&
               <button className="btn btn-link accent-link top-margin-half big-left-margin" onClick={this.openGameTypeModal}>
                  (Edit)
               </button>}
            </div>

            {isEvent &&
            <div className="clear-left top-margin-half">
               <h4 className="inline secondary-highlight">
                  Event Starts:
                  <span className="left-margin red-text">
                                    {eventDateMoment}
                                </span>
               </h4>
            </div>
            }

            <PrivatePublicBlock className="clear-left col-xs-12 col-sm-8 col-md-8 no-side-margins"
                                game = {game}
                                editable={editable}
                                fetchCodeClicked={() => fetchGame(this.gameId())}
                                onConvertClicked={() => this.onConvertClick()}
                                genQuickLinkClicked={() => this.genQuickLinkClicked()}
            />

            <div className="clear-left">
               <h3 className="inline big-top-margin secondary-highlight">
                  Hunt Picture
                  {editable ?
                     <SimpleFileInput
                        labelText={photoButtonText}
                        value={[]}
                        onChange={this.onDrop}
                        accept="image/*"
                     />
                  : ""}

               </h3>
            </div>
            <p className="explanation secondary-text right-margin-only">
               Optional.  Photo or illustration to introduce this hunt.  Shown on the hunt summary page in app; landscape images work best.
            </p>

            <PhotoUpload
               url={game.hunt_picture}
               loading={this.state.loadingImage}
               editable={editable}
               deletedCallback={() => {
                  deleteFileInFbStorage(game.hunt_picture);
                  this.photoUploadComplete(null) }
               }
               errorCallback={this.errorUploadingPhoto}
            />

            <div className="clear-left">
               <h3 className="inline big-top-margin secondary-highlight">
                  Introduction
                  {editable ?
                     <button className="btn btn-link edit-button accent-link" onClick={this.openIntroductionModal}>
                         (Edit)
                     </button>
                     : ""}
               </h3>
            </div>
            <p className="user">
               {game[INTRO]}
            </p>

            <div>
               <h3 className="inline secondary-highlight">
                  Hunt Ending

                  {editable ?
                     <button className="btn btn-link left-margin edit-button accent-link" onClick={this.openHuntEndingModal}>
                        (Edit)
                     </button>
                     : ""}
               </h3>
            </div>

            <div className=""> <span> Treasure Type: </span>
               <span className="left-margin  user-written bold"> {game[TREASURE_TYPE]} </span></div>
            <div className="">  <span> Message: </span>
               <span className="left-margin  user-written user">  {game[TREASURE_DESCRIPTION]} </span></div>

            {/*From here, split into two columns.  Clues on the left, the rest of the game info on the right. */}

            <div className="top-margin clear-all">
               <MainClueList
                  game={game}
                  editable={editable}
               />

               {!bounds &&
                  <div> Game bounds are required to create clues. </div>
               }
            </div>

            {/* The Modals */}
            {/* If state says a modal is open, show it. */}

            {/* Edit Game details: title etc. */}
            <Modal
               isOpen={this.state.editDetailsModalIsOpen}
               onRequestClose={this.closeDetailsModal}
               className="my-modal-content"
               overlayClassName="my-modal-overlay"
            >
               <UpdateDetails
                  closeModalCallback={this.closeDetailsModal}
               />
            </Modal>

            {/* Edit game type, etcl*/}
            <Modal
               isOpen={this.state.editGameTypeModalIsOpen}
               onRequestClose={this.closeGameTypeModal}
               className="my-modal-content"
               overlayClassName="my-modal-overlay"
            >
               <UpdateGameType
                  closeModalCallback={this.closeGameTypeModal}
               />
            </Modal>

            {/* Convert public/private */}
            <Modal
               isOpen={this.state.convertConfirmationModalIsOpen}
               onRequestClose={this.closeConvertConfirmationModal}
               className="my-modal-content"
               overlayClassName="my-modal-overlay"
            >
               <MessageDialog
                  title={confirmTitle}
                  message={confirmMessage}
                  buttonText="Yes!"
                  closeModalCallback={this.closeConvertConfirmationModal}
                  callback={this.convertGameConfirmed}
               />

            </Modal>

            {/* Edit Intro */}
            <Modal
               isOpen={this.state.editIntroModalIsOpen}
               onRequestClose={this.closeIntroductionModal}
               className="my-modal-content"
               overlayClassName="my-modal-overlay"
            >
               <UpdateIntro
                  closeModalCallback={this.closeIntroductionModal}
               />
            </Modal>

            {/* Edit Map modal*/}
            <Modal
               isOpen={this.state.editMapModalIsOpen}
               onRequestClose={this.closeMapModal}
               className="my-modal-content"
               overlayClassName="my-modal-overlay"
            >
               <EditMapBounds
                  bounds={bounds}
                  height={dialogDims.height}
                  width={dialogDims.width}
                  closeModalCallback={this.closeMapModal}
                  title="Treasure Hunt Bounds"
               />
            </Modal>

            {/* Edit hunt ending modal*/}
            <Modal
               isOpen={this.state.editHuntEndingModalIsOpen}
               onRequestClose={this.closeHuntEndingModal}
               className="my-modal-content"
               overlayClassName="my-modal-overlay"
            >
               <HuntEnding
                  isModal={true}
                  game={game}
                  closeModalCallback={this.closeHuntEndingModal}
                  afterDoneCallback={this.closeHuntEndingModal}
               />
            </Modal>

            {/*Pop up to confirm delete of game.*/}
            <Modal
               isOpen={this.state.deleteConfirmIsOpen}
               onRequestClose={this.closeDeleteModal}
               className="confirm-modal-content"
               overlayClassName="my-modal-overlay"
            >
               <ConfirmDelete
                  title="Delete Game"
                  message="Are you sure you want to permanantly delete this game and its clues?"
                  confirmText="Delete"
                  onConfirm={this.onDelete}
                  closeModalCallback={this.closeDeleteModal}
               />
            </Modal>

            {this.state.isFetching && <div className="my-modal-overlay"/>}
            {this.state.isFetching && <div className="loader"/>}
         </div>
      )
   }
}

function buildConfirmMessage(isPublic, isPublished) {
   return isPublic
      ? isPublished
         ? "Being private makes it only available to those you invite."           // the \n's do not work.
         : "Being private makes it only available to those you invite, once published."
      : isPublished
         ? "Going public makes it available to everyone! Yay!"
         : "Going public will, once published, make it available to everyone. Thank you."
}

const authCondition = (authUser) => !!authUser;

// boilerplate redux, tie in our app state to props
function mapStateToProps(state) {
   return {
      games: state.games,
      ipLocation: state.userState.ipLocation,
      user: state.userState.user,
      isAdmin: state.sessionState.isAdmin,
      clueIcons: state.clueIcons
   };
}

export default compose(
   withAuthorization(authCondition),
   connect(mapStateToProps, {fetchGame, fetchAndAttachAuthorToGame, deleteGame, selectGame}),
   withRouter,
   windowSize
)(GameDetail);



// WEBPACK FOOTER //
// ./src/components/huntedit/GameDetail.js